import { createContext } from 'use-context-selector'
import { OrganizationSellerContextProps } from './types'
export const OrganizationSellerContext = createContext(
  {} as OrganizationSellerContextProps
)
